import {Component} from '@angular/core';
import {FooterModule} from "../../components/footer/footer.module";

/** Privacy policy: which personal data the shop keeps, why, and who else receives it. */
@Component({
    selector: 'app-privacy-policy',
    standalone: true,
    imports: [FooterModule],
    template: `
        <article class="px-5 pt-[8.5rem] lg:pt-52 pb-16 max-w-3xl mx-auto text-left text-gray-800 leading-relaxed">
            <h1 class="text-2xl lg:text-4xl font-bold text-gray-900">Политика за приватност</h1>
            <p class="pt-3">
                Оваа страница објаснува кои лични податоци ги собира aloeveragel.mk, зошто ги собира и кому ги дава.
                Податоците ги обработуваме согласно Законот за заштита на личните податоци.
            </p>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Кои податоци ги собираме</h2>
            <ul class="list-disc pl-5 pt-2 space-y-1">
                <li><strong>При нарачка:</strong> име и презиме, телефонски број, адреса за достава и, ако го внесете, е-маил.</li>
                <li><strong>При мислење за производ:</strong> име, град и оценката и текстот што ги пишувате. Телефонот, ако го внесете, служи само за ознаката „Потврден купувач“ и не се објавува.</li>
                <li><strong>При пријава за потсетник или новости:</strong> е-маил адресата.</li>
                <li><strong>При најава на профил:</strong> е-маил и име од сметката со која се најавувате.</li>
                <li><strong>При посета на сајтот:</strong> технички податоци за прелистувачот и страниците што ги гледате, преку колачињата наведени подолу.</li>
            </ul>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Зошто ги користиме</h2>
            <ul class="list-disc pl-5 pt-2 space-y-1">
                <li>за да ја испорачаме нарачката и да ве контактираме ако имаме прашање за неа;</li>
                <li>за да ви пратиме потврда за нарачката, а по испораката и една порака со која ве прашуваме за мислење;</li>
                <li>за потсетникот за повторна нарачка, само ако сте го побарале;</li>
                <li>за промоции и новости, само ако сте се пријавиле за нив;</li>
                <li>за да видиме како се користи сајтот и да го подобриме.</li>
            </ul>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Кому ги даваме</h2>
            <p class="pt-2">Податоците не ги продаваме. Ги добиваат само услугите без кои продавницата не може да работи:</p>
            <ul class="list-disc pl-5 pt-2 space-y-1">
                <li><strong>Курирската служба</strong> (Eco Logistics) – име, телефон, адреса и износ за наплата, за да ја достави пратката;</li>
                <li><strong>Google</strong> – Gmail за праќање е-пошта, Google Analytics за статистика на посети;</li>
                <li><strong>Meta</strong> (Facebook пиксел) – за мерење на рекламите;</li>
                <li><strong>Auth0</strong> – за најава на профил.</li>
            </ul>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Колачиња (cookies)</h2>
            <p class="pt-2">
                Сајтот користи колачиња од Google Analytics, Google и Meta за статистика и мерење на рекламите, и
                локално складирање во прелистувачот за содржината на кошничката. Колачињата можете да ги избришете
                или блокирате во поставките на вашиот прелистувач – кошничката и нарачката работат и без нив.
            </p>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Колку долго ги чуваме</h2>
            <p class="pt-2">
                Податоците од нарачките ги чуваме онолку колку што бараат даночните и сметководствените прописи.
                Е-маил адресата за новости ја чуваме додека не се одјавите, а адресата за потсетник се користи само за еден мејл.
            </p>

            <h2 class="pt-8 text-xl font-semibold text-gray-900">Вашите права</h2>
            <p class="pt-2">
                Имате право да побарате увид во податоците што ги имаме за вас, да ги исправите, да побарате да ги избришеме
                или да се откажете од промотивни пораки. Пишете ни на
                <a class="text-primaryDark underline" href="mailto:aloeveragel.mk@gmail.com">aloeveragel.mk&#64;gmail.com</a>
                или јавете се на <a class="text-primaryDark underline whitespace-nowrap" href="tel:+38973857133">073/857-133</a>.
                Ако сметате дека податоците не ги обработуваме правилно, можете да поднесете барање до
                Агенцијата за заштита на личните податоци.
            </p>
        </article>
        <app-footer></app-footer>
    `
})
export class PrivacyPolicyComponent {
}
